<template>
  <div class="retailTile relative flex flex-direction-column">
    <div class="retailTile--image-container">
      <div class="overlay"></div>
      <a class="block" :href="data.link" target="_blank">
        <img v-if="data.thumbnail_image_url" :src="data.thumbnail_image_url" />
        <div v-else class="image-placeholder icon-upload-image"></div>
      </a>
    </div>
    <div class="retailTile--description-container width-100 mt-20 mt-40-sm">
      <a
        :href="data.link"
        target="_blank"
        v-trackevent="{'action': 'Click Discovery Landing Page Brand Tile'}"
        class="mr-20 mb-5-sm mr-0-sm block">
        <div class="font-size-24 cambon-book-sm">{{ data.name }}</div>
        <div v-html="data.mov" class="bold font-size-14" />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base/vars.scss";
@import "../../../assets/sass/base/helpers.scss";

.retailerTile {
  .retailerTile--image-container {
    position: relative;

    .overlay {
      pointer-events: none;
      cursor: pointer;
      opacity: 0;
      position: absolute;
      width: 100%;
      height: 50%;
      top: 50%;
      background: linear-gradient(to bottom, transparent, #d3b6fe);
      -webkit-transition: all 0.2s ease;
      -moz-transition: all 0.2s ease;
      -o-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }

    img {
      &.hasBorders {
        border: 1px solid black;
      }
    }

    .image-placeholder {
      height: 100%;
      background-size: 50%;
      background-position: center;
    }
  }

  &:hover .brandTile--image-container .overlay {
    opacity: 0.7;
  }

  .retailerTile--description-container {
    position: relative;

    h4,
    a {
      -webkit-transition: all 0.2s ease;
      -moz-transition: all 0.2s ease;
      -o-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }

    @include respond-to("small") {
      text-align: center;
    }
  }

  &:hover .retailerTile--description-container {
    h4,
    a {
      opacity: 0.7;
    }
  }

  .favorite--wrapper {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
